// extracted by mini-css-extract-plugin
module.exports = {"qualificationContent":"AuditorStandards_qualificationContent__2evNs","justification":"AuditorStandards_justification__1LJb5"};